import axios from '../utils/axios'

// // 获取时长列表
export function getUserWatchListApi(params = {}) {
  return axios.post('/live/apiWxaliveAwService/getUserWatchList', params)
}

export function getLiveUserWatchListApi(params={}){
  return axios.post('/live/apiWxaliveAwService/getLiveroomUserWatchList', params)
} 
